import {
    api_admin_companies_del,
    api_admin_companies_get,
    api_companies_get,
    Company,
} from 'abi'
import { addAlert } from 'components'
import { createStore } from 'solid-js/store'
import { self } from 'store/self'
import { deepcopy } from 'utils/tools'

type CSTATE = {
    loading: boolean
    error: boolean

    edit: boolean
    corp: Company | null
}
const CSTATE_DEFAULT: CSTATE = {
    corp: null,

    edit: false,

    error: false,
    loading: true,
}

const [cState, setCState] = createStore<CSTATE>(deepcopy(CSTATE_DEFAULT))

export const ResetCstate = () => {
    setCState(deepcopy(CSTATE_DEFAULT))
}

export const fetchCorp = async (id: number, admin: boolean) => {
    setCState({ loading: true })

    let res

    if (admin) {
        res = await api_admin_companies_get({ id })
    } else {
        res = await api_companies_get({ cid: id })
    }

    setCState({ loading: false })

    if (!res.ok()) return setCState({ error: true })

    setCState('corp', res.body)
}

export const DelCorp = async (id: number, onDone: () => void) => {
    setCState({ loading: true })

    let res = await api_admin_companies_del({ id })

    setCState({ loading: false })

    if (!res.ok()) return setCState({ error: true })

    onDone()
}

export const NoPermsForThisCorp = () => {
    addAlert({
        type: 'error',
        timeout: 3,
        subject: 'خطا دسترسی!',
        content: 'شما مجوز دسترسی به این شرکت را ندارید!',
    })
}

export const isAdmin = () => {
    return self.Aperms.any()
}

export const isCorpManager = (cid: number) => {
    return self.user?.staff_at == cid && self.staff_role == 'manager'
}

export const isInCorp = (cid: number) => {
    return self.user?.staff_at == cid
}

export { cState, setCState }
